// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_1tVK6","status":"index_status_2RIYC","footer":"index_footer_183xd"};